import { z } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const DashboardSnapshotSchema = z.object({
    tenantSlug: z.string(),
    timestamp: z.string(),
    totalAgentsOnline: z.number(),
    agentStatusCounts: z.record(z.number()),
    queueDepths: z.record(z.number()),
    longestWaitMs: z.number(),
    activeCalls: z.number(),
    slaPercent: z.number(),
    abandonRatePercent: z.number(),
});
export const DashboardUpdateEventSchema = z.object({
    type: z.literal('dashboard.update'),
    ...baseEventFields,
    snapshot: DashboardSnapshotSchema,
});
//# sourceMappingURL=dashboard.js.map